import { useState, createContext } from 'react'

export const GlobalStoreContext = createContext({})

const GlobalStore = ({ children }) => {
    const [isLogin, setIsLogin] = useState(false)
    const  [currentTab, setCurrentTab] = useState(0)

    const [userInfo, setUserInfo] = useState({
        name: 'TGB官方旗舰店'
    })
    const [previewData, setPreviewData] = useState({})

    return (
        <GlobalStoreContext.Provider
            value={{
                userInfo,
                setUserInfo: (newInfo) => {
                    const result = Object.assign({}, newInfo)
                    setUserInfo(newInfo)
                },
                isLogin,
                currentTab,
                setCurrentTab,
                previewData,
                setPreviewData,
                setIsLogin,
            }}
        >

            {children}
        </GlobalStoreContext.Provider>
    )
}

export default GlobalStore